'use client';

import { useEffect } from 'react';

let lockCount = 0;
let previousOverflow = '';
let previousPaddingRight = '';

export function useBodyScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    if (lockCount === 0) {
      // 스크롤바가 사라지며 생기는 레이아웃 밀림(CLS)을 그 폭만큼 padding으로 상쇄
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      previousOverflow = document.body.style.overflow;
      previousPaddingRight = document.body.style.paddingRight;
      document.body.style.overflow = 'hidden';

      if (scrollbarWidth > 0) {
        const basePadding =
          parseFloat(getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = `${basePadding + scrollbarWidth}px`;
        // body는 padding으로 콘텐츠를 보정하지만, 뷰포트 기준 position:fixed 팝업은
        // 이 padding의 영향을 받지 않으므로 같은 폭을 CSS 변수로 노출해 따로 보정한다
        document.documentElement.style.setProperty(
          '--scrollbar-lock-width',
          `${scrollbarWidth}px`
        );
      }
    }

    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);

      if (lockCount === 0) {
        document.body.style.overflow = previousOverflow;
        document.body.style.paddingRight = previousPaddingRight;
        document.documentElement.style.removeProperty('--scrollbar-lock-width');
        previousOverflow = '';
        previousPaddingRight = '';
      }
    };
  }, [locked]);
}
